module.exports = __webpack_public_path__ + "static/media/rectangle-14.d6037d27.svg";